import React from 'react';

function BillingWhite(props) {
  return (
    <svg viewBox="0 0 28 28" {...props}>
      <g fill="#FFF" fillRule="evenodd">
        <path
          d="M22.998 10.833a.374.374 0 00-.38-.366H8.14a.374.374 0 00-.381.366v8.8c0 .203.17.367.381.367h14.476c.21 0 .381-.164.381-.367v-8.8z"
          opacity={0.2}
        />
        <path d="M20.4 10.923c0 .212-.18.385-.4.385h-1.6c-.22 0-.4-.173-.4-.385 0-.212.18-.385.4-.385H20c.22 0 .4.173.4.385zM10 17.077c0 .211-.18.385-.4.385H8c-.22 0-.4-.174-.4-.385 0-.212.18-.385.4-.385h1.6c.22 0 .4.173.4.385zM14 17a3 3 0 110-6 3 3 0 010 6zm8-7.615A.393.393 0 0021.6 9H6.4c-.22 0-.4.172-.4.385v9.23c0 .213.18.385.4.385h15.2c.22 0 .4-.172.4-.385v-9.23z" />
      </g>
    </svg>
  );
}

export default BillingWhite;
